import { ApiError } from '@botto/core';
import { tariffsApi } from '../client';
import type { components } from '../generated/schema';

export type UserTariffResponse = components['schemas']['UserTariffResponse'];
export type UserTariffUpdateRequest = components['schemas']['UserTariffUpdateRequest'];

export async function fetchUserTariff(userId: number): Promise<UserTariffResponse | null> {
  try {
    const { data, error } = await tariffsApi.GET('/users/{user_id}/tariffs', {
      params: { path: { user_id: userId } },
    });
    if (error) throw error;
    return data ?? null;
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) return null;
    throw e;
  }
}

export async function upsertUserTariff(
  body: UserTariffUpdateRequest,
): Promise<UserTariffResponse> {
  const { data, error } = await tariffsApi.PUT('/users/tariffs', { body });
  if (error) throw error;
  return data!;
}
